module.exports = __webpack_public_path__ + "static/img/warning.845210e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/warning.png
// module id = QcOD
// module chunks = 1